import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/AxiosConfig";
import BlogCard from "../../Cards/BlogCard";
import { useInitialData } from "../../../SSR/InitialDataContext";
import "../../../Styles/Blogs.css";

function Blogs() {
  const initialData = useInitialData();
  const initialBlogs = Array.isArray(initialData?.blogsPage?.blogs)
    ? initialData.blogsPage.blogs
    : [];
  const [blogs, setBlogs] = useState(initialBlogs);
  const [loading, setLoading] = useState(initialBlogs.length === 0);

  useEffect(() => {
    if (initialBlogs.length > 0) {
      setLoading(false);
      return undefined;
    }

    let isMounted = true;

    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get("/blogs", {
          params: {
            limit: 100,
          },
        });

        if (!isMounted) {
          return;
        }

        setBlogs(Array.isArray(response.data?.data) ? response.data.data : []);
      } catch (error) {
        if (isMounted) {
          setBlogs([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchBlogs();

    return () => {
      isMounted = false;
    };
  }, [initialBlogs.length]);

  return (
    <div className="blogs-page">
      <div className="blogs-page__container">
        <header className="blogs-header">
          {/* <p className="blogs-header__eyebrow">Elumia Insights</p> */}
          <h1>Blogs</h1>
          <p>
            Insights, buying guidance, and wellness knowledge curated for
            clinics, pharmacies, and healthcare buyers.
          </p>
        </header>

        {loading ? (
          <div className="blogs-empty">Loading blogs...</div>
        ) : blogs.length ? (
          <section className="blogs-grid">
            {blogs.map((blog) => (
              <BlogCard key={blog.id || blog.slug} blog={blog} />
            ))}
          </section>
        ) : (
          <div className="blogs-empty">
            <h2>No blogs available right now</h2>
            <p>Please check back soon for fresh healthcare insights.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Blogs;
